import { render, staticRenderFns } from "./FiltersMenu.vue?vue&type=template&id=e4bce614"
import script from "./FiltersMenu.vue?vue&type=script&lang=ts"
export * from "./FiltersMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports